import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _148fb592 = () => interopDefault(import('../pages/_lang/index.vue' /* webpackChunkName: "pages/_lang/index" */))
const _0bd11c46 = () => interopDefault(import('../pages/_lang/404.vue' /* webpackChunkName: "pages/_lang/404" */))
const _15b88a4c = () => interopDefault(import('../pages/_lang/about-us/index.vue' /* webpackChunkName: "pages/_lang/about-us/index" */))
const _3a8142d5 = () => interopDefault(import('../pages/_lang/account/index.vue' /* webpackChunkName: "pages/_lang/account/index" */))
const _463cd5b7 = () => interopDefault(import('../pages/_lang/add-socks-regular.vue' /* webpackChunkName: "pages/_lang/add-socks-regular" */))
const _6ff86f8e = () => interopDefault(import('../pages/_lang/add-undershirts.vue' /* webpackChunkName: "pages/_lang/add-undershirts" */))
const _8dd4d296 = () => interopDefault(import('../pages/_lang/affiliate/index.vue' /* webpackChunkName: "pages/_lang/affiliate/index" */))
const _a43ae31e = () => interopDefault(import('../pages/_lang/cancel-membership/index.vue' /* webpackChunkName: "pages/_lang/cancel-membership/index" */))
const _84e16df0 = () => interopDefault(import('../pages/_lang/contact/index.vue' /* webpackChunkName: "pages/_lang/contact/index" */))
const _e2302d02 = () => interopDefault(import('../pages/_lang/cookie-declaration/index.vue' /* webpackChunkName: "pages/_lang/cookie-declaration/index" */))
const _55902434 = () => interopDefault(import('../pages/_lang/customer-service/index.vue' /* webpackChunkName: "pages/_lang/customer-service/index" */))
const _1600b2e0 = () => interopDefault(import('../pages/_lang/data-request-success/index.vue' /* webpackChunkName: "pages/_lang/data-request-success/index" */))
const _777ddcdd = () => interopDefault(import('../pages/_lang/delete-request-deleted-success/index.vue' /* webpackChunkName: "pages/_lang/delete-request-deleted-success/index" */))
const _1a2a4491 = () => interopDefault(import('../pages/_lang/delete-request-success/index.vue' /* webpackChunkName: "pages/_lang/delete-request-success/index" */))
const _2221ee1a = () => interopDefault(import('../pages/_lang/eauta-for-men/index.vue' /* webpackChunkName: "pages/_lang/eauta-for-men/index" */))
const _7dad6ccb = () => interopDefault(import('../pages/_lang/explore-memberships/index.vue' /* webpackChunkName: "pages/_lang/explore-memberships/index" */))
const _d1c75c9e = () => interopDefault(import('../pages/_lang/imprint/index.vue' /* webpackChunkName: "pages/_lang/imprint/index" */))
const _81406f64 = () => interopDefault(import('../pages/_lang/login.vue' /* webpackChunkName: "pages/_lang/login" */))
const _576471ae = () => interopDefault(import('../pages/_lang/loyalty/index.vue' /* webpackChunkName: "pages/_lang/loyalty/index" */))
const _cb5ee484 = () => interopDefault(import('../pages/_lang/men/index.vue' /* webpackChunkName: "pages/_lang/men/index" */))
const _1aa47c0b = () => interopDefault(import('../pages/_lang/password-reset/index.vue' /* webpackChunkName: "pages/_lang/password-reset/index" */))
const _206fd992 = () => interopDefault(import('../pages/_lang/privacy-statement/index.vue' /* webpackChunkName: "pages/_lang/privacy-statement/index" */))
const _7dfc9ad4 = () => interopDefault(import('../pages/_lang/reactivate/index.vue' /* webpackChunkName: "pages/_lang/reactivate/index" */))
const _74bbd425 = () => interopDefault(import('../pages/_lang/refer-a-friend/index.vue' /* webpackChunkName: "pages/_lang/refer-a-friend/index" */))
const _e1301174 = () => interopDefault(import('../pages/_lang/referred-by-friend/index.vue' /* webpackChunkName: "pages/_lang/referred-by-friend/index" */))
const _4acea162 = () => interopDefault(import('../pages/_lang/right-of-withdrawal/index.vue' /* webpackChunkName: "pages/_lang/right-of-withdrawal/index" */))
const _3af586c6 = () => interopDefault(import('../pages/_lang/signup/index.vue' /* webpackChunkName: "pages/_lang/signup/index" */))
const _29763cd6 = () => interopDefault(import('../pages/_lang/sustainability/index.vue' /* webpackChunkName: "pages/_lang/sustainability/index" */))
const _5fe406e2 = () => interopDefault(import('../pages/_lang/terms-and-conditions/index.vue' /* webpackChunkName: "pages/_lang/terms-and-conditions/index" */))
const _101f0f76 = () => interopDefault(import('../pages/_lang/terms-of-use/index.vue' /* webpackChunkName: "pages/_lang/terms-of-use/index" */))
const _7bc906b2 = () => interopDefault(import('../pages/_lang/transaction-confirmation/index.vue' /* webpackChunkName: "pages/_lang/transaction-confirmation/index" */))
const _2d2073ac = () => interopDefault(import('../pages/_lang/try-now/index.vue' /* webpackChunkName: "pages/_lang/try-now/index" */))
const _74165a3d = () => interopDefault(import('../pages/_lang/undershirts/index.vue' /* webpackChunkName: "pages/_lang/undershirts/index" */))
const _9d5d569c = () => interopDefault(import('../pages/_lang/webshop/index.vue' /* webpackChunkName: "pages/_lang/webshop/index" */))
const _3dd502b4 = () => interopDefault(import('../pages/_lang/women/index.vue' /* webpackChunkName: "pages/_lang/women/index" */))
const _549ed943 = () => interopDefault(import('../pages/_lang/account/loyalty-program/index.vue' /* webpackChunkName: "pages/_lang/account/loyalty-program/index" */))
const _7a753bba = () => interopDefault(import('../pages/_lang/account/memberships/index.vue' /* webpackChunkName: "pages/_lang/account/memberships/index" */))
const _da215e16 = () => interopDefault(import('../pages/_lang/account/orders/index.vue' /* webpackChunkName: "pages/_lang/account/orders/index" */))
const _0876b0f6 = () => interopDefault(import('../pages/_lang/account/personal-details/index.vue' /* webpackChunkName: "pages/_lang/account/personal-details/index" */))
const _eca47efa = () => interopDefault(import('../pages/_lang/account/request-personal-details/index.vue' /* webpackChunkName: "pages/_lang/account/request-personal-details/index" */))
const _12af72fc = () => interopDefault(import('../pages/_lang/customer-service/pause-cancel/index.vue' /* webpackChunkName: "pages/_lang/customer-service/pause-cancel/index" */))
const _60c2fa8d = () => interopDefault(import('../pages/_lang/men/customer-service/index.vue' /* webpackChunkName: "pages/_lang/men/customer-service/index" */))
const _05526f42 = () => interopDefault(import('../pages/_lang/men/signup/index.vue' /* webpackChunkName: "pages/_lang/men/signup/index" */))
const _5d55b174 = () => interopDefault(import('../pages/_lang/socks/reactivate/index.vue' /* webpackChunkName: "pages/_lang/socks/reactivate/index" */))
const _2375b3e4 = () => interopDefault(import('../pages/_lang/undershirts/reactivate/index.vue' /* webpackChunkName: "pages/_lang/undershirts/reactivate/index" */))
const _51754c5c = () => interopDefault(import('../pages/_lang/women/bra-size/index.vue' /* webpackChunkName: "pages/_lang/women/bra-size/index" */))
const _3a9e12b6 = () => interopDefault(import('../pages/_lang/women/customer-service/index.vue' /* webpackChunkName: "pages/_lang/women/customer-service/index" */))
const _a87e14f4 = () => interopDefault(import('../pages/_lang/women/product/index.vue' /* webpackChunkName: "pages/_lang/women/product/index" */))
const _41f753f6 = () => interopDefault(import('../pages/_lang/women/reactivate/index.vue' /* webpackChunkName: "pages/_lang/women/reactivate/index" */))
const _df96fb12 = () => interopDefault(import('../pages/_lang/women/signup/index.vue' /* webpackChunkName: "pages/_lang/women/signup/index" */))
const _3680669c = () => interopDefault(import('../pages/_lang/account/memberships/add.vue' /* webpackChunkName: "pages/_lang/account/memberships/add" */))
const _4e09a9d8 = () => interopDefault(import('../pages/_lang/account/personal-details/contact-info.vue' /* webpackChunkName: "pages/_lang/account/personal-details/contact-info" */))
const _ca336e90 = () => interopDefault(import('../pages/_lang/account/personal-details/password.vue' /* webpackChunkName: "pages/_lang/account/personal-details/password" */))
const _7eaa3dee = () => interopDefault(import('../pages/_lang/account/personal-details/payment-details.vue' /* webpackChunkName: "pages/_lang/account/personal-details/payment-details" */))
const _f32ea164 = () => interopDefault(import('../pages/_lang/account/personal-details/personal-info.vue' /* webpackChunkName: "pages/_lang/account/personal-details/personal-info" */))
const _bde750c0 = () => interopDefault(import('../pages/_lang/account/personal-details/security/index.vue' /* webpackChunkName: "pages/_lang/account/personal-details/security/index" */))
const _6b2054ca = () => interopDefault(import('../pages/_lang/men/signup/boxershort/index.vue' /* webpackChunkName: "pages/_lang/men/signup/boxershort/index" */))
const _b1af6cf8 = () => interopDefault(import('../pages/_lang/men/signup/choose-design/index.vue' /* webpackChunkName: "pages/_lang/men/signup/choose-design/index" */))
const _8311f03c = () => interopDefault(import('../pages/_lang/men/signup/create-account/index.vue' /* webpackChunkName: "pages/_lang/men/signup/create-account/index" */))
const _648aa00a = () => interopDefault(import('../pages/_lang/men/signup/sizechart.vue' /* webpackChunkName: "pages/_lang/men/signup/sizechart" */))
const _437e68d8 = () => interopDefault(import('../pages/_lang/men/signup/sold-out.vue' /* webpackChunkName: "pages/_lang/men/signup/sold-out" */))
const _290c8860 = () => interopDefault(import('../pages/_lang/webshop/checkout/payment/index.vue' /* webpackChunkName: "pages/_lang/webshop/checkout/payment/index" */))
const _2c57520c = () => interopDefault(import('../pages/_lang/webshop/checkout/shipping/index.vue' /* webpackChunkName: "pages/_lang/webshop/checkout/shipping/index" */))
const _4b0a799c = () => interopDefault(import('../pages/_lang/women/signup/choose-design/index.vue' /* webpackChunkName: "pages/_lang/women/signup/choose-design/index" */))
const _d24a4a6c = () => interopDefault(import('../pages/_lang/women/signup/create-account/index.vue' /* webpackChunkName: "pages/_lang/women/signup/create-account/index" */))
const _55897b96 = () => interopDefault(import('../pages/_lang/women/signup/free-gift.vue' /* webpackChunkName: "pages/_lang/women/signup/free-gift" */))
const _38d79060 = () => interopDefault(import('../pages/_lang/account/memberships/overview/address/index.vue' /* webpackChunkName: "pages/_lang/account/memberships/overview/address/index" */))
const _2ae6094a = () => interopDefault(import('../pages/_lang/account/memberships/overview/boxershorts/index.vue' /* webpackChunkName: "pages/_lang/account/memberships/overview/boxershorts/index" */))
const _448f0678 = () => interopDefault(import('../pages/_lang/account/memberships/overview/member/index.vue' /* webpackChunkName: "pages/_lang/account/memberships/overview/member/index" */))
const _ac6217c8 = () => interopDefault(import('../pages/_lang/account/memberships/overview/status/index.vue' /* webpackChunkName: "pages/_lang/account/memberships/overview/status/index" */))
const _3d337e11 = () => interopDefault(import('../pages/_lang/account/personal-details/security/data-request/index.vue' /* webpackChunkName: "pages/_lang/account/personal-details/security/data-request/index" */))
const _0e90dc35 = () => interopDefault(import('../pages/_lang/account/personal-details/security/deletion-request/index.vue' /* webpackChunkName: "pages/_lang/account/personal-details/security/deletion-request/index" */))
const _635e0f87 = () => interopDefault(import('../pages/_lang/men/signup/create-account/address/index.vue' /* webpackChunkName: "pages/_lang/men/signup/create-account/address/index" */))
const _a516cca2 = () => interopDefault(import('../pages/_lang/men/signup/create-account/double-check/index.vue' /* webpackChunkName: "pages/_lang/men/signup/create-account/double-check/index" */))
const _004a3812 = () => interopDefault(import('../pages/_lang/men/signup/create-account/verification-payment/index.vue' /* webpackChunkName: "pages/_lang/men/signup/create-account/verification-payment/index" */))
const _f4985d2c = () => interopDefault(import('../pages/_lang/webshop/checkout/payment/confirmation/index.vue' /* webpackChunkName: "pages/_lang/webshop/checkout/payment/confirmation/index" */))
const _2f4f5628 = () => interopDefault(import('../pages/_lang/women/signup/create-account/address.vue' /* webpackChunkName: "pages/_lang/women/signup/create-account/address" */))
const _20c11be2 = () => interopDefault(import('../pages/_lang/women/signup/create-account/verification-payment/index.vue' /* webpackChunkName: "pages/_lang/women/signup/create-account/verification-payment/index" */))
const _3542aedc = () => interopDefault(import('../pages/_lang/men/signup/create-account/verification-payment/declined/index.vue' /* webpackChunkName: "pages/_lang/men/signup/create-account/verification-payment/declined/index" */))
const _1c61e8eb = () => interopDefault(import('../pages/_lang/men/signup/create-account/verification-payment/failed/index.vue' /* webpackChunkName: "pages/_lang/men/signup/create-account/verification-payment/failed/index" */))
const _30d4f702 = () => interopDefault(import('../pages/_lang/men/signup/create-account/verification-payment/pending/index.vue' /* webpackChunkName: "pages/_lang/men/signup/create-account/verification-payment/pending/index" */))
const _c8ebb82a = () => interopDefault(import('../pages/_lang/men/signup/create-account/verification-payment/success/index.vue' /* webpackChunkName: "pages/_lang/men/signup/create-account/verification-payment/success/index" */))
const _2f7d8bfe = () => interopDefault(import('../pages/_lang/women/signup/create-account/verification-payment/declined.vue' /* webpackChunkName: "pages/_lang/women/signup/create-account/verification-payment/declined" */))
const _07d2f560 = () => interopDefault(import('../pages/_lang/women/signup/create-account/verification-payment/failed.vue' /* webpackChunkName: "pages/_lang/women/signup/create-account/verification-payment/failed" */))
const _9270d9d8 = () => interopDefault(import('../pages/_lang/women/signup/create-account/verification-payment/pending.vue' /* webpackChunkName: "pages/_lang/women/signup/create-account/verification-payment/pending" */))
const _28d33380 = () => interopDefault(import('../pages/_lang/women/signup/create-account/verification-payment/success.vue' /* webpackChunkName: "pages/_lang/women/signup/create-account/verification-payment/success" */))
const _93ea98e4 = () => interopDefault(import('../pages/_lang/account/memberships/_id/index.vue' /* webpackChunkName: "pages/_lang/account/memberships/_id/index" */))
const _6f1ce960 = () => interopDefault(import('../pages/_lang/account/orders/_id/index.vue' /* webpackChunkName: "pages/_lang/account/orders/_id/index" */))
const _a49c3470 = () => interopDefault(import('../pages/_lang/men/customer-service/_topic/index.vue' /* webpackChunkName: "pages/_lang/men/customer-service/_topic/index" */))
const _0726c2a0 = () => interopDefault(import('../pages/_lang/women/customer-service/_topic/index.vue' /* webpackChunkName: "pages/_lang/women/customer-service/_topic/index" */))
const _75838ae8 = () => interopDefault(import('../pages/_lang/account/memberships/_id/ad-details.vue' /* webpackChunkName: "pages/_lang/account/memberships/_id/ad-details" */))
const _7279ee20 = () => interopDefault(import('../pages/_lang/account/memberships/_id/boxer-shorts.vue' /* webpackChunkName: "pages/_lang/account/memberships/_id/boxer-shorts" */))
const _24d4d508 = () => interopDefault(import('../pages/_lang/account/memberships/_id/cancel-membership/index.vue' /* webpackChunkName: "pages/_lang/account/memberships/_id/cancel-membership/index" */))
const _5832e804 = () => interopDefault(import('../pages/_lang/account/memberships/_id/details.vue' /* webpackChunkName: "pages/_lang/account/memberships/_id/details" */))
const _4445a28c = () => interopDefault(import('../pages/_lang/account/memberships/_id/reactivated.vue' /* webpackChunkName: "pages/_lang/account/memberships/_id/reactivated" */))
const _773e4894 = () => interopDefault(import('../pages/_lang/account/orders/_id/pay.vue' /* webpackChunkName: "pages/_lang/account/orders/_id/pay" */))
const _687d7152 = () => interopDefault(import('../pages/_lang/account/orders/_id/return/_orderId.vue' /* webpackChunkName: "pages/_lang/account/orders/_id/return/_orderId" */))
const _230f18ed = () => interopDefault(import('../pages/_lang/men/signup/_membershipType/_design/index.vue' /* webpackChunkName: "pages/_lang/men/signup/_membershipType/_design/index" */))
const _b21672fe = () => interopDefault(import('../pages/_lang/women/signup/_bralette/_hipster/index.vue' /* webpackChunkName: "pages/_lang/women/signup/_bralette/_hipster/index" */))
const _3e874a96 = () => interopDefault(import('../pages/_lang/explore-memberships/_membershipTypeReference/index.vue' /* webpackChunkName: "pages/_lang/explore-memberships/_membershipTypeReference/index" */))
const _132014e0 = () => interopDefault(import('../pages/_lang/lookbook/_orientation/index.vue' /* webpackChunkName: "pages/_lang/lookbook/_orientation/index" */))
const _00775494 = () => interopDefault(import('../pages/_lang/open-payment/_paymentId/index.vue' /* webpackChunkName: "pages/_lang/open-payment/_paymentId/index" */))
const _7b9f52d4 = () => interopDefault(import('../pages/_lang/password-reset/_token/index.vue' /* webpackChunkName: "pages/_lang/password-reset/_token/index" */))
const _7717fad0 = () => interopDefault(import('../pages/_lang/open-payment/_paymentId/paid.vue' /* webpackChunkName: "pages/_lang/open-payment/_paymentId/paid" */))
const _514228fb = () => interopDefault(import('../pages/_lang/open-payment/_paymentId/pending.vue' /* webpackChunkName: "pages/_lang/open-payment/_paymentId/pending" */))
const _79646d32 = () => interopDefault(import('../pages/_lang/open-payment/_paymentId/success.vue' /* webpackChunkName: "pages/_lang/open-payment/_paymentId/success" */))
const _11697398 = () => interopDefault(import('../pages/_lang/lookbook/_orientation/_slug.vue' /* webpackChunkName: "pages/_lang/lookbook/_orientation/_slug" */))
const _af84c790 = () => interopDefault(import('../pages/_lang/webshop/_category/_slug.vue' /* webpackChunkName: "pages/_lang/webshop/_category/_slug" */))
const _c801d742 = () => interopDefault(import('../pages/_lang/_specialDesignUrl/index.vue' /* webpackChunkName: "pages/_lang/_specialDesignUrl/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/:lang",
    component: _148fb592,
    name: "lang"
  }, {
    path: "/:lang?/404",
    component: _0bd11c46,
    name: "lang-404"
  }, {
    path: "/:lang?/about-us",
    component: _15b88a4c,
    name: "lang-about-us"
  }, {
    path: "/:lang?/account",
    component: _3a8142d5,
    name: "lang-account"
  }, {
    path: "/:lang?/add-socks-regular",
    component: _463cd5b7,
    name: "lang-add-socks-regular"
  }, {
    path: "/:lang?/add-undershirts",
    component: _6ff86f8e,
    name: "lang-add-undershirts"
  }, {
    path: "/:lang?/affiliate",
    component: _8dd4d296,
    name: "lang-affiliate"
  }, {
    path: "/:lang?/cancel-membership",
    component: _a43ae31e,
    name: "lang-cancel-membership"
  }, {
    path: "/:lang?/contact",
    component: _84e16df0,
    name: "lang-contact"
  }, {
    path: "/:lang?/cookie-declaration",
    component: _e2302d02,
    name: "lang-cookie-declaration"
  }, {
    path: "/:lang?/customer-service",
    component: _55902434,
    name: "lang-customer-service"
  }, {
    path: "/:lang?/data-request-success",
    component: _1600b2e0,
    name: "lang-data-request-success"
  }, {
    path: "/:lang?/delete-request-deleted-success",
    component: _777ddcdd,
    name: "lang-delete-request-deleted-success"
  }, {
    path: "/:lang?/delete-request-success",
    component: _1a2a4491,
    name: "lang-delete-request-success"
  }, {
    path: "/:lang?/eauta-for-men",
    component: _2221ee1a,
    name: "lang-eauta-for-men"
  }, {
    path: "/:lang?/explore-memberships",
    component: _7dad6ccb,
    name: "lang-explore-memberships"
  }, {
    path: "/:lang?/imprint",
    component: _d1c75c9e,
    name: "lang-imprint"
  }, {
    path: "/:lang?/login",
    component: _81406f64,
    name: "lang-login"
  }, {
    path: "/:lang?/loyalty",
    component: _576471ae,
    name: "lang-loyalty"
  }, {
    path: "/:lang?/men",
    component: _cb5ee484,
    name: "lang-men"
  }, {
    path: "/:lang?/password-reset",
    component: _1aa47c0b,
    name: "lang-password-reset"
  }, {
    path: "/:lang?/privacy-statement",
    component: _206fd992,
    name: "lang-privacy-statement"
  }, {
    path: "/:lang?/reactivate",
    component: _7dfc9ad4,
    name: "lang-reactivate"
  }, {
    path: "/:lang?/refer-a-friend",
    component: _74bbd425,
    name: "lang-refer-a-friend"
  }, {
    path: "/:lang?/referred-by-friend",
    component: _e1301174,
    name: "lang-referred-by-friend"
  }, {
    path: "/:lang?/right-of-withdrawal",
    component: _4acea162,
    name: "lang-right-of-withdrawal"
  }, {
    path: "/:lang?/signup",
    component: _3af586c6,
    name: "lang-signup"
  }, {
    path: "/:lang?/sustainability",
    component: _29763cd6,
    name: "lang-sustainability"
  }, {
    path: "/:lang?/terms-and-conditions",
    component: _5fe406e2,
    name: "lang-terms-and-conditions"
  }, {
    path: "/:lang?/terms-of-use",
    component: _101f0f76,
    name: "lang-terms-of-use"
  }, {
    path: "/:lang?/transaction-confirmation",
    component: _7bc906b2,
    name: "lang-transaction-confirmation"
  }, {
    path: "/:lang?/try-now",
    component: _2d2073ac,
    name: "lang-try-now"
  }, {
    path: "/:lang?/undershirts",
    component: _74165a3d,
    name: "lang-undershirts"
  }, {
    path: "/:lang?/webshop",
    component: _9d5d569c,
    name: "lang-webshop"
  }, {
    path: "/:lang?/women",
    component: _3dd502b4,
    name: "lang-women"
  }, {
    path: "/:lang?/account/loyalty-program",
    component: _549ed943,
    name: "lang-account-loyalty-program"
  }, {
    path: "/:lang?/account/memberships",
    component: _7a753bba,
    name: "lang-account-memberships"
  }, {
    path: "/:lang?/account/orders",
    component: _da215e16,
    name: "lang-account-orders"
  }, {
    path: "/:lang?/account/personal-details",
    component: _0876b0f6,
    name: "lang-account-personal-details"
  }, {
    path: "/:lang?/account/request-personal-details",
    component: _eca47efa,
    name: "lang-account-request-personal-details"
  }, {
    path: "/:lang?/customer-service/pause-cancel",
    component: _12af72fc,
    name: "lang-customer-service-pause-cancel"
  }, {
    path: "/:lang?/men/customer-service",
    component: _60c2fa8d,
    name: "lang-men-customer-service"
  }, {
    path: "/:lang?/men/signup",
    component: _05526f42,
    name: "lang-men-signup"
  }, {
    path: "/:lang?/socks/reactivate",
    component: _5d55b174,
    name: "lang-socks-reactivate"
  }, {
    path: "/:lang?/undershirts/reactivate",
    component: _2375b3e4,
    name: "lang-undershirts-reactivate"
  }, {
    path: "/:lang?/women/bra-size",
    component: _51754c5c,
    name: "lang-women-bra-size"
  }, {
    path: "/:lang?/women/customer-service",
    component: _3a9e12b6,
    name: "lang-women-customer-service"
  }, {
    path: "/:lang?/women/product",
    component: _a87e14f4,
    name: "lang-women-product"
  }, {
    path: "/:lang?/women/reactivate",
    component: _41f753f6,
    name: "lang-women-reactivate"
  }, {
    path: "/:lang?/women/signup",
    component: _df96fb12,
    name: "lang-women-signup"
  }, {
    path: "/:lang?/account/memberships/add",
    component: _3680669c,
    name: "lang-account-memberships-add"
  }, {
    path: "/:lang?/account/personal-details/contact-info",
    component: _4e09a9d8,
    name: "lang-account-personal-details-contact-info"
  }, {
    path: "/:lang?/account/personal-details/password",
    component: _ca336e90,
    name: "lang-account-personal-details-password"
  }, {
    path: "/:lang?/account/personal-details/payment-details",
    component: _7eaa3dee,
    name: "lang-account-personal-details-payment-details"
  }, {
    path: "/:lang?/account/personal-details/personal-info",
    component: _f32ea164,
    name: "lang-account-personal-details-personal-info"
  }, {
    path: "/:lang?/account/personal-details/security",
    component: _bde750c0,
    name: "lang-account-personal-details-security"
  }, {
    path: "/:lang?/men/signup/boxershort",
    component: _6b2054ca,
    name: "lang-men-signup-boxershort"
  }, {
    path: "/:lang?/men/signup/choose-design",
    component: _b1af6cf8,
    name: "lang-men-signup-choose-design"
  }, {
    path: "/:lang?/men/signup/create-account",
    component: _8311f03c,
    name: "lang-men-signup-create-account"
  }, {
    path: "/:lang?/men/signup/sizechart",
    component: _648aa00a,
    name: "lang-men-signup-sizechart"
  }, {
    path: "/:lang?/men/signup/sold-out",
    component: _437e68d8,
    name: "lang-men-signup-sold-out"
  }, {
    path: "/:lang?/webshop/checkout/payment",
    component: _290c8860,
    name: "lang-webshop-checkout-payment"
  }, {
    path: "/:lang?/webshop/checkout/shipping",
    component: _2c57520c,
    name: "lang-webshop-checkout-shipping"
  }, {
    path: "/:lang?/women/signup/choose-design",
    component: _4b0a799c,
    name: "lang-women-signup-choose-design"
  }, {
    path: "/:lang?/women/signup/create-account",
    component: _d24a4a6c,
    name: "lang-women-signup-create-account"
  }, {
    path: "/:lang?/women/signup/free-gift",
    component: _55897b96,
    name: "lang-women-signup-free-gift"
  }, {
    path: "/:lang?/account/memberships/overview/address",
    component: _38d79060,
    name: "lang-account-memberships-overview-address"
  }, {
    path: "/:lang?/account/memberships/overview/boxershorts",
    component: _2ae6094a,
    name: "lang-account-memberships-overview-boxershorts"
  }, {
    path: "/:lang?/account/memberships/overview/member",
    component: _448f0678,
    name: "lang-account-memberships-overview-member"
  }, {
    path: "/:lang?/account/memberships/overview/status",
    component: _ac6217c8,
    name: "lang-account-memberships-overview-status"
  }, {
    path: "/:lang?/account/personal-details/security/data-request",
    component: _3d337e11,
    name: "lang-account-personal-details-security-data-request"
  }, {
    path: "/:lang?/account/personal-details/security/deletion-request",
    component: _0e90dc35,
    name: "lang-account-personal-details-security-deletion-request"
  }, {
    path: "/:lang?/men/signup/create-account/address",
    component: _635e0f87,
    name: "lang-men-signup-create-account-address"
  }, {
    path: "/:lang?/men/signup/create-account/double-check",
    component: _a516cca2,
    name: "lang-men-signup-create-account-double-check"
  }, {
    path: "/:lang?/men/signup/create-account/verification-payment",
    component: _004a3812,
    name: "lang-men-signup-create-account-verification-payment"
  }, {
    path: "/:lang?/webshop/checkout/payment/confirmation",
    component: _f4985d2c,
    name: "lang-webshop-checkout-payment-confirmation"
  }, {
    path: "/:lang?/women/signup/create-account/address",
    component: _2f4f5628,
    name: "lang-women-signup-create-account-address"
  }, {
    path: "/:lang?/women/signup/create-account/verification-payment",
    component: _20c11be2,
    name: "lang-women-signup-create-account-verification-payment"
  }, {
    path: "/:lang?/men/signup/create-account/verification-payment/declined",
    component: _3542aedc,
    name: "lang-men-signup-create-account-verification-payment-declined"
  }, {
    path: "/:lang?/men/signup/create-account/verification-payment/failed",
    component: _1c61e8eb,
    name: "lang-men-signup-create-account-verification-payment-failed"
  }, {
    path: "/:lang?/men/signup/create-account/verification-payment/pending",
    component: _30d4f702,
    name: "lang-men-signup-create-account-verification-payment-pending"
  }, {
    path: "/:lang?/men/signup/create-account/verification-payment/success",
    component: _c8ebb82a,
    name: "lang-men-signup-create-account-verification-payment-success"
  }, {
    path: "/:lang?/women/signup/create-account/verification-payment/declined",
    component: _2f7d8bfe,
    name: "lang-women-signup-create-account-verification-payment-declined"
  }, {
    path: "/:lang?/women/signup/create-account/verification-payment/failed",
    component: _07d2f560,
    name: "lang-women-signup-create-account-verification-payment-failed"
  }, {
    path: "/:lang?/women/signup/create-account/verification-payment/pending",
    component: _9270d9d8,
    name: "lang-women-signup-create-account-verification-payment-pending"
  }, {
    path: "/:lang?/women/signup/create-account/verification-payment/success",
    component: _28d33380,
    name: "lang-women-signup-create-account-verification-payment-success"
  }, {
    path: "/:lang?/account/memberships/:id",
    component: _93ea98e4,
    name: "lang-account-memberships-id"
  }, {
    path: "/:lang?/account/orders/:id",
    component: _6f1ce960,
    name: "lang-account-orders-id"
  }, {
    path: "/:lang?/men/customer-service/:topic",
    component: _a49c3470,
    name: "lang-men-customer-service-topic"
  }, {
    path: "/:lang?/women/customer-service/:topic",
    component: _0726c2a0,
    name: "lang-women-customer-service-topic"
  }, {
    path: "/:lang?/account/memberships/:id/ad-details",
    component: _75838ae8,
    name: "lang-account-memberships-id-ad-details"
  }, {
    path: "/:lang?/account/memberships/:id/boxer-shorts",
    component: _7279ee20,
    name: "lang-account-memberships-id-boxer-shorts"
  }, {
    path: "/:lang?/account/memberships/:id/cancel-membership",
    component: _24d4d508,
    name: "lang-account-memberships-id-cancel-membership"
  }, {
    path: "/:lang?/account/memberships/:id/details",
    component: _5832e804,
    name: "lang-account-memberships-id-details"
  }, {
    path: "/:lang?/account/memberships/:id/reactivated",
    component: _4445a28c,
    name: "lang-account-memberships-id-reactivated"
  }, {
    path: "/:lang?/account/orders/:id/pay",
    component: _773e4894,
    name: "lang-account-orders-id-pay"
  }, {
    path: "/:lang?/account/orders/:id/return/:orderId?",
    component: _687d7152,
    name: "lang-account-orders-id-return-orderId"
  }, {
    path: "/:lang?/men/signup/:membershipType/:design",
    component: _230f18ed,
    name: "lang-men-signup-membershipType-design"
  }, {
    path: "/:lang?/women/signup/:bralette/:hipster",
    component: _b21672fe,
    name: "lang-women-signup-bralette-hipster"
  }, {
    path: "/:lang?/explore-memberships/:membershipTypeReference",
    component: _3e874a96,
    name: "lang-explore-memberships-membershipTypeReference"
  }, {
    path: "/:lang?/lookbook/:orientation",
    component: _132014e0,
    name: "lang-lookbook-orientation"
  }, {
    path: "/:lang?/open-payment/:paymentId",
    component: _00775494,
    name: "lang-open-payment-paymentId"
  }, {
    path: "/:lang?/password-reset/:token",
    component: _7b9f52d4,
    name: "lang-password-reset-token"
  }, {
    path: "/:lang?/open-payment/:paymentId?/paid",
    component: _7717fad0,
    name: "lang-open-payment-paymentId-paid"
  }, {
    path: "/:lang?/open-payment/:paymentId?/pending",
    component: _514228fb,
    name: "lang-open-payment-paymentId-pending"
  }, {
    path: "/:lang?/open-payment/:paymentId?/success",
    component: _79646d32,
    name: "lang-open-payment-paymentId-success"
  }, {
    path: "/:lang?/lookbook/:orientation?/:slug",
    component: _11697398,
    name: "lang-lookbook-orientation-slug"
  }, {
    path: "/:lang?/webshop/:category/:slug?",
    component: _af84c790,
    name: "lang-webshop-category-slug"
  }, {
    path: "/:lang?/:specialDesignUrl",
    component: _c801d742,
    name: "lang-specialDesignUrl"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
